export function isDevelopmentPageEnabled() {
	return isPiletTestsAccount() || isTestSubdomainWithDevPageEnabled();
}

function isPiletTestsAccount() {
	// This account is used for the playwright tests
	return /pilet-tests.sharefile.*\.com/.test(window.location.hostname);
}
function isTestSubdomainWithDevPageEnabled(): boolean {
	return ['aiteam.sharefiletest.com'].includes(window.location.hostname);
}
